import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import FontOffsetParams from "./FontOffsetParams";
import FontOffsetCalculator from "./FontOffsetCalculator";

export default class TextOffsetFixer {

    constructor() {
        if (TextOffsetFixer._instance != null) {
            throw new Error("TextPositionFix already instantiated.");
        }
        this._paramsPerFont = {};
    }

    _initialize() {
        //Flag that we are initializing to avoid infinite recursion
        //  due to the fact that TextOffsetCalculator.calculateFontParameters instantiates a skin which will call TextPositionFix.applyFix
        this._initializing = true;
        //Obtain parameters per font from TextOffsetCalculator and transfer to this._paramsPerFont
        const paramsPerFont = FontOffsetCalculator.calculateFontOffsetParameters();
        const entries = Object.entries(paramsPerFont);
        for (const [fontName, fontParams] of entries) {
            this._paramsPerFont[fontName] = fontParams;
        }
        //Use first font as default
        this._paramsPerFont._default = entries[0][1];
        this._initializing = false;
    }

    /**
     * @param {createjs.Text} target Textfield to fix position of.
     */
    _fix(target) {
        if (this._initializing || !(target instanceof createjs.Text)) {
            return;
        }

        const fontSize = TextUtil.getFontSize(target);
        if (isNaN(fontSize)) {
            return;
        }

        const fontName = TextUtil.getFontName(target).toLowerCase();
        /**@type {FontOffsetParams} */
        const fontParams = this._paramsPerFont[fontName] || this._paramsPerFont._default;

        // fix x
        const dx = fontParams.xOffset + fontParams.xMultiplier * fontSize;
        if (!target.textAlign || target.textAlign === "left") {
            target.x += dx;
        } else if (target.textAlign === "center") {
            target.x += dx / 2;
        }

        // fix y
        target.y += fontParams.yOffset + fontParams.yMultiplier * fontSize;
    }

    /**
     * @type {TextOffsetFixer}
     */
    static get instance() {
        if (TextOffsetFixer._instance == null) {
            TextOffsetFixer._instance = new TextOffsetFixer();
            TextOffsetFixer._instance._initialize();
        }
        return TextOffsetFixer._instance;
    }

    /**
     * This method is meant to be called from asset scripts exported by Adobe Animate.
     * The method call is typically injected during build process.
     * It should be called only once on a textfield.
    
     * @param {createjs.Text} target Textfield to fix position of.
     * @returns target createjs.Text object for chaining
     */
    static fix(target) {
        return TextOffsetFixer.instance._fix(target);
    }
}



